<script setup lang="ts">
// This component is added by us, shuriken/tairo doesn't have a BaseLabel component.
</script>

<template>
  <label class="text-muted-800 dark:text-muted-200 w-full pb-2 text-sm font-medium"><slot /></label>
</template>
